import { RoleItem } from "@/features/ACL/type";
import MyAxios from "@/utilize/MyAxios";
import { useQuery } from "@tanstack/react-query";

export const useGetRolesEmployeeCount = () => {
  return useQuery({
    queryFn: () =>
      MyAxios.get<{
        items: RoleItem[];
      }>("/acl/roles/employee-count").then((res) => res.data),
    queryKey: ["rolesEmployeeCount"],
  });
};
